import React, { lazy } from "react";
import { useRoutes } from "react-router-dom";
import { retry } from "../common/utils/commonFunction";
import { Navigate } from "react-router-dom";

const FaqPage = lazy(() => retry(() => import("../pages/Faq")));
const TAndCPage = lazy(() => retry(() => import("../pages/TAndCPage")));
const PrivacyPolicyPage = lazy(() =>
  retry(() => import("../pages/PrivacyPolicyPage"))
);
const LandingPage = lazy(() => retry(() => import("../pages/LandingPage")));
const PaymentSuccessPage = lazy(() =>
  retry(() => import("../pages/PaymentSuccessPage"))
);
const PaymentFailurePage = lazy(() =>
  retry(() => import("../pages/PaymentFailurePage"))
);
const FourOhFour = lazy(() => retry(() => import("../pages/FourOhFour")));
const Routes = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/faqs",
      element: <FaqPage />,
    },
    {
      path: "/payment-successful",
      element: <PaymentSuccessPage />,
    },
    {
      path: "/payment-failed",
      element: <PaymentFailurePage />,
    },
    {
      path: "/terms-and-conditions",
      element: <TAndCPage />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicyPage />,
    },
    {
      path: "/*",
      element: <Navigate replace to="/404" />,
    },
    {
      path: "/404",
      element: <FourOhFour />,
    },
  ]);

  return routes;
};

export default Routes;
